import { HubConnectionBuilder } from "@microsoft/signalr";
import appConfig from "../../app-config";

class SessionNotificationHub {
  constructor() {
    this.client = new HubConnectionBuilder()
      .withUrl(`${appConfig.VUE_APP_ROOT_API}/api/session-notification-hub`)
      .withAutomaticReconnect()
      .build();

    this.client.on("ReceiveSessionNotification", (message) => {
      // eslint-disable-next-line no-console
      console.log("Session Notification Received: ", message);
      // You can add additional logic here to handle the notification
    });
  }
  start() {
    this.client
      .start()
      .then(() => {
        // eslint-disable-next-line no-console
        console.log("SessionNotificationHub Connected")
      })
      .catch((err) =>
        // eslint-disable-next-line no-console
        console.log("Error while establishing connection :(" + err)
      );
  }
}

export default new SessionNotificationHub();
